import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import {ToggleFullscreenDirective} from './fullscreen/toggle-fullscreen.directive';
import {AccordionAnchorDirective} from './accordion/accordionanchor.directive';
import {AccordionLinkDirective} from './accordion/accordionlink.directive';
import {AccordionDirective} from './accordion/accordion.directive';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ScrollModule} from './scroll/scroll.module';

import {MenuItems} from './menu-items/menu-items';
import {SpinnerComponent} from './spinner/spinner.component';
import {CardComponent} from './card/card.component';
import {CardRefreshDirective} from './card/card-refresh.directive';
import {CardToggleDirective} from './card/card-toggle.directive';
import {ModalAnimationComponent} from './modal-animation/modal-animation.component';
import {ModalBasicComponent} from './modal-basic/modal-basic.component';
import {DataFilterPipe} from "./element/data-filter.pipe";
import {PageloaderComponent} from './pageloader/pageloader.component'
import { NgxSpinnerModule } from 'ngx-spinner';
import { RouterModule } from '@angular/router';
import { VoiceToText } from './voicetotext-input/voicetotext.component';
import { SpeechService } from '../services/speech.service';
import { AuMobileValidatorDirective } from './validators/au-mobile.directive';
import { JobInventorySummaryComponent } from './components/job-inventory-summary/job-inventory-summary.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ScrollModule,
    NgbModule,
    NgxSpinnerModule
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    CardRefreshDirective,
    CardToggleDirective,
    SpinnerComponent,
    CardComponent,
    ModalAnimationComponent,
    ModalBasicComponent,
    DataFilterPipe,
    PageloaderComponent,
    VoiceToText,
    AuMobileValidatorDirective,
    JobInventorySummaryComponent
  ],
  exports: [
    RouterModule,
    FormsModule,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    CardRefreshDirective,
    CardToggleDirective,
    ScrollModule,
    NgbModule,
    SpinnerComponent,
    CardComponent,
    ModalAnimationComponent,
    ModalBasicComponent,
    DataFilterPipe,
    PageloaderComponent,
    VoiceToText,
    AuMobileValidatorDirective,
    JobInventorySummaryComponent,
    NgxSpinnerModule
  ],
  providers: [
    MenuItems,
    SpeechService
  ]
})
export class SharedModule { }
